module.exports = __webpack_public_path__ + "static/img/2-1-1.0dbd913e.jpg";